import React from "react";
import AddStudentExamData from "../../components/AdminTabs/AdminResult/StaffAddStudentData";

const AddStudentData = () => {
  return (
    <div>
      <AddStudentExamData />
    </div>
  );
};

export default AddStudentData;
